import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ProviderPageLayout from '../../components/ProviderPageLayout';
import { useAuth } from '../../auth/useAuth';

const ProviderOwnerManual = () => {
  const navigate = useNavigate();
  const { user, loading: authLoading, signOut } = useAuth();

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate('/provider/login?next=/provider/manual', { replace: true });
    }
  }, [user, authLoading, navigate]);

  const handleSignOut = async () => {
    await signOut();
    navigate('/provider/login');
  };

  if (authLoading || !user) {
    return (
      <ProviderPageLayout variant="app" wide onSignOut={handleSignOut}>
        <div className="provider-loading">
          <div className="provider-spinner" aria-hidden="true" />
          <span>Loading manual…</span>
        </div>
      </ProviderPageLayout>
    );
  }

  return (
    <ProviderPageLayout variant="app" wide onSignOut={handleSignOut}>
      <div className="provider-manual-shell">
        <div className="provider-manual-toolbar">
          <div>
            <p className="provider-eyebrow" style={{ marginBottom: 6 }}>
              Device guide
            </p>
            <h1 className="provider-manual-title">CupFate Owner&apos;s Manual</h1>
            <p className="provider-page-meta">
              Setup, daily use, and troubleshooting for your CupFate device.
            </p>
          </div>
          <Link to="/provider/" className="provider-btn provider-btn--secondary provider-btn--sm provider-btn--inline">
            ← Back to dashboard
          </Link>
        </div>

        <div className="provider-manual-frame-wrap">
          <iframe
            title="CupFate Owner's Manual"
            className="provider-manual-frame"
            src="/provider/cupfate-owner-manual.html"
          />
        </div>
      </div>
    </ProviderPageLayout>
  );
};

export default ProviderOwnerManual;
